"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoPlayer_1 = require("./VideoPlayer");
exports.default = VideoPlayer_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/VideoPlayer/index.js
// module id = 1289
// module chunks = 8